import { EyeOutlined, SearchOutlined, ShareAltOutlined } from '@ant-design/icons'
import { Button, Space, Table, Input } from 'antd'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import { useTableDataSourceKey } from '~/hooks/useTableDataSourceKey'
import { compareNumber, compareText } from '~/utils/helpers'
import { useCoursesQuery } from './query'

const Workstations = () => {
  const { data: courses, isLoading: coursesLoading } = useCoursesQuery()
  const coursesSource = useTableDataSourceKey(courses)

  const columns = () => [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: (a, b) => compareNumber(a.id, b.id)
    },
    {
      title: 'Title',
      render: (course) => (
        <Link to={`/admin/courses/${course.id}/workstations`}>{course.name}</Link>
      ),
      sorter: (a, b) => compareText(a.name, b.name)
    },
    {
      title: 'Software',
      render: (course) => {
        if (!course.software) {
          return ''
        }

        return <div>{course.software.name}</div>
      }
    },
    {
      title: 'Total Workstations',
      render: (course) => course.participants?.length ?? 0
    },
    {
      title: 'Actions',
      render: (course) => {
        return (
          <Space size="middle">
            <Link to={`/admin/courses/${course.id}/workstations`}>
              <Button type="primary" icon={<EyeOutlined />} />
            </Link>
            <Button type="primary" icon={<ShareAltOutlined />} />
          </Space>
        )
      }
    }
  ]

  const [filterInput, setFilterInput] = useState('')

  const filterCourses = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!coursesSource) {
      return 0
    }

    return coursesSource.filter((course) => course.name.toLowerCase().includes(filter))
  }, [coursesSource, filterInput])

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title="Workstations"
        extra={[
          <Input.Search
            key={1}
            placeholder="Search"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />
        ]}
      />
      <Table
        size="small"
        tableLayout="auto"
        dataSource={filterCourses}
        columns={columns()}
        loading={coursesLoading}
      />
    </>
  )
}

export default Workstations
